export default {"src":"/_next/static/media/confusedIcon.bcb44bf8.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};